import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { SaveUserStateToServerHelper } from "./Helper";
import { start, changeView } from "../actions/assessment";
import imgBulb from "./../assets/img/icon-bulb.svg";
import config from "../config/config-secret.json";

import { Translate } from "react-redux-i18n";
import Button from "./ui/Buttons/Button";

export class JobApplication extends Component {
  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  start = () => {
    if (this.props.is_ptsd) {
      this.props.show_ptsd();
      return;
    }

    if (this.props.assessment.current_question_number === 1) {
      const tester_id = this.props.assessment.tester_id;

      axios
        .post(config.API_URL + "/administer_test/started/", {
          tester_id: tester_id,
        })
        .then((res) => {
          console.log(res.data);
          document.querySelector("#initloader").style.display = "none";
          this.props.start();
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.log(error);
          alert("Something went wrong. Please refresh the page.");
        });
    } else {
      this.props.start();
    }
  };

  render() {
    const i18n = require("react-redux-i18n").I18n;

    return (
      <div className="main container-fluid h-100">
        <div className="row test-container align-items-md-center">
          <div className="col-12">
            <div className="container">
              <div className="test-instruction ">
                <div className="row  justify-content-center ">
                  <div className="col-md- ">
                    <h3 className="mt-5 mb-4">
                      <Translate value="job_application_instruction" />
                    </h3>
                    <div className="reminder">
                      <img
                        src={imgBulb}
                        className="d-table-cell"
                        width="30px"
                        height="30px"
                        alt={i18n.t("instruct")}
                      />
                      <p className="lead">
                        <Translate value="instruct_lead" />
                      </p>
                    </div>
                    <div>
                      <p className="pt-2">
                        <Translate value="job_application_instruction_part_one" />
                      </p>
                      <p className="pt-2">
                        <Translate value="job_application_instruction_part_two" />
                      </p>
                      <p className="pt-2">
                        <Translate value="job_application_instruction_part_three" />
                      </p>
                    </div>
                    {/* <div
                                            dangerouslySetInnerHTML={{
                                                __html: this.props.instruction
                                            }}
                                        ></div> */}
                    <p className="pt-2">
                      <Translate value="instruct_start" />
                    </p>

                    <div className="mt-4">
                      <div className="button-wrap mt-md-5">
                        {/* <button
                          onClick={this.props.show_job_application_form1}
                          className="btn btn-main btn-global ord-1"
                        >
                          <Translate value="start" />
                        </button>
                        <button
                          onClick={this.props.exit_session}
                          className="btn btn-outline-white btn-global ord-2"
                        >
                          <Translate value="exit_session" />
                        </button> */}
                        <Button
                          variant="primary"
                          className="btn-global ord-1"
                          onClick={this.props.show_job_application_form1}
                        >
                          <Translate value="close" />
                        </Button>
                        <Button
                          variant="outline-white"
                          className="btn-global ord-2"
                          onClick={this.props.exit_session}
                        >
                          <Translate value="exit_session" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  instruction: state.assessment.exams[state.assessment.exam_index].instruction,
  is_ptsd: state.assessment.exams[state.assessment.exam_index].is_ptsd,
});

const mapDispatchToProps = (dispatch) => ({
  start: () => dispatch(start()),
  show_job_application_form1: () =>
    dispatch(changeView("job_application_form1")),
  exit_session: () => dispatch(changeView("session_details")),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobApplication);
